export enum StatusType {
	Error = 'error',
	Failed = 'failed',
	Processed = 'processed',
	Processing = 'processing',
	Rejected = 'rejected'
}

export const TransactionHistoryTabNames = {
	Chiliz: 'currency',
	FanTokens: 'fan-tokens'
} as const;

export type TransactionHistorySegments = (typeof TransactionHistoryTabNames)[keyof typeof TransactionHistoryTabNames];
